<template>
    <div class="about-us">
        <div class="sub-logo">
            <img src="/static/img/fairtility.logo.png" alt="fairtility" />
        </div>
        <div class="main-logo">
            <img src="/static/svg/chloe_logo.svg" alt="fairtility" />
        </div>

        <div class="version-text">V {{ version }}</div>

        <div class="image-with-content">
            <div class="img-div">
                <img src="/static/img/ltd.png" alt="" />
            </div>

            <div class="text-div">
                <p>Fairtility Ltd.</p>
                <p>8 Ha’Melacha St., Tel-Aviv, Israel, 6721508</p>
            </div>
        </div>

        <div class="image-with-content">
            <div class="img-div">
                <img src="/static/img/ec.rep.png" alt="" />
            </div>
            <div class="text-div">
                <p>MedNet EC-REP GmbH</p>
                <p>Borkstrasse 10, 48163 Münster, Germany</p>
            </div>
        </div>

        <div class="image-with-content">
            <div class="img-div">
                AUSTRALIAN <br />
                SPONSOR
            </div>
            <div class="text-div">
                <p>AA-Med Pty. Ltd</p>
                <p>Suite 10.04, 1 Chandos Street, St Leonards NSW 2065, Australia</p>
                <p>Tel: 1300 887 807</p>
            </div>
        </div>

        <div class="image-with-content">
            <div class="img-div">
                <img src="/static/img/udi.png" alt="" />
            </div>
            <div class="text-div">
                <p>00860007211300</p>
            </div>
        </div>

        <div class="last-logo">
            <img src="/static/img/ce.md.i.png" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AboutUs',
    props: {
        version: {
            type: String,
            default: '0.0.0'
        }
    }
}
</script>
<style lang="scss" scoped>
.about-us {
    width: 100%;
    text-align: center;
    .sub-logo {
        margin-top: 3rem;
    }
    .main-logo {
        margin-top: 3rem;
        margin-bottom: 1.5rem;
        img {
            max-width: 15rem;
        }
    }
    .version-text {
        margin-bottom: 4rem;
    }
    .image-with-content {
        display: flex;
        align-items: center;
        gap: 2rem;
        margin-top: 1rem;
        .img-div {
            flex: 2;
            text-align: right;
        }
        .text-div {
            flex: 3;
            text-align: left;

            p {
                margin: 0;
                font-size: 0.8rem;
            }
        }
    }
    .last-logo {
        margin-top: 4rem;
    }
}
</style>

<style lang="scss">
.about-us-modal {
    padding-left: 0 !important;

    button.close {
        font-size: 2.5rem;
        padding: 0.6rem;
        font-weight: normal;
        opacity: 1;
    }
    .modal-dialog {
        width: 100%;
        max-width: 1040px;
    }
}
</style>








